module.exports = __webpack_public_path__ + "img/Google Pay.3908c2f6.png";